export default "__VITE_ASSET__Bovoo_Ik__"